import {ErrorMessage, Field, Form, Formik} from "formik";
import * as Yup from 'yup';
import SkodaDataInfo from "./SkodaDataInfo";
import SkodaDataMoreInfo from "./SkodaDataMoreInfo";
import postData from "../services/postData";
import Modal from "./Modal";
import {useState} from "react";
import {ScrollToFieldError} from "./formik/ScrollToFieldError";

export default function ServiceForm({setLoadingSpinnerOpen}) {

    const formType = 'wizyta_w_serwisie,bp';

    const [successModal, setSuccessModal] = useState(false);
    const [failureModal, setFailureModal] = useState(false);
    const [formIsSubmitting, setFormIsSubmitting] = useState(false);

    const dataLayerPush = (orderId) => {
        try {
            window.dataLayer.push({
                'event': 'formularze',
                'wypelniony-formularz': 'wizyta-w-serwisie-zamowiono',
                'orderid': orderId
            });
            console.log('dataLayer.push ok:', orderId);
        } catch (err) {
            console.error('dataLayer.push error:', err);
        }
    };

    const syneriseSendFormData = (orderId, values) => {
        if (!('SR' in window)) {
            console.error('SR undefined');
            return;
        }

        const snrData = {
            orderID: orderId,
            firstname: values.firstName,
            phone: values.phone,
        };

        try {
            window.SR.event.sendFormData(formType, snrData)
                .then((res) => {
                    console.log(formType);
                    console.log(res);
                })
                .catch((err) => {
                    console.log(formType);
                    console.error(err);
                });
        } catch (err) {
            console.error('SR error', err);
        }
    };

    return (
        <Formik
            initialValues={{
                firstName: '',
                phone: '',
                agreeData: false,
                agreeCommunication: [],
            }}
            validationSchema={
                Yup.object().shape({
                    firstName: Yup.string()
                        .required('Wpisz imię.')
                        .min(2, 'Imię jest za krótkie.')
                        .max(50)
                        .matches(/^[\p{L} ]+$/gu, 'Podaj prawidłowe imię.'),
                    phone: Yup.string()
                        .required('Wpisz nr\u00a0telefonu.')
                        .matches(/^\d{9}$/, 'Podaj nr\u00a0telefonu w\u00a0formacie 123456789.'),
                    agreeData: Yup.boolean()
                        .when('agreeCommunication', {
                            is: (val) => val && val.length > 0,
                            then: (schema) => schema.isTrue('Zaznacz, jeśli wybrałeś minimum jedną z\u00a0poniższych opcji.'),
                        }),
                    agreeCommunication: Yup.array()
                        .when('agreeData', {
                            is: (val) => true === val,
                            then: (schema) => schema.min(1, 'Wybierz minimum jedną opcję.'),
                        }),
                }, ['agreeData', 'agreeCommunication'])
            }
            onSubmit={(values, actions) => {
                actions.setSubmitting(false);
                setFormIsSubmitting(true);
                setLoadingSpinnerOpen(true);

                postData(values)
                    .then((data) => {
                        if (data && data.status === 'ok') {
                            dataLayerPush(data.orderId);
                            syneriseSendFormData(data.orderId, values);
                            actions.resetForm();
                            setSuccessModal(true);
                        } else {
                            setFailureModal(true);
                        }
                    })
                    .catch((error) => {
                        setFailureModal(true);
                    })
                    .finally(() => {
                        setFormIsSubmitting(false);
                        setLoadingSpinnerOpen(false);
                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: "smooth"
                        });
                    });
            }}
        >
            {(formikProps) => (
                <>
                    <Modal open={successModal} setOpen={setSuccessModal}>
                        Skontaktujemy się z&nbsp;Tobą w&nbsp;celu potwierdzenia Twoich zgód na&nbsp;działania marketingowe naszej marki w&nbsp;przyszłości. Na podany adres e-mail lub na podany numer telefonu zadzownimy/wyślemy SMS, z&nbsp;prośbą o&nbsp;potwierdzenie zgód poprzez kliknięcie w&nbsp;przesłany link.
                    </Modal>

                    <Modal open={failureModal} setOpen={setFailureModal}>
                        Wystąpił błąd!<br/>
                        Prosimy spróbować później.
                    </Modal>

                    <Form className="ServiceForm" method={`post`}>
                        <ScrollToFieldError />

                        <div className="ServiceForm__field">
                            <div className="form-group">
                                <label htmlFor="firstName">Imię*</label>
                                <Field id="firstName" name="firstName" type="text" placeholder="Imię*" className="form-control" maxLength={50}></Field>
                                <ErrorMessage name="firstName">{msg => <div className="form-errors">{msg}</div>}</ErrorMessage>
                            </div>
                        </div>

                        <div className="ServiceForm__field">
                            <div className="form-group">
                                <label htmlFor="phone">Telefon*</label>
                                <Field id="phone" name="phone" type="tel" placeholder="Telefon*" className="form-control" maxLength={9}></Field>
                                <ErrorMessage name="phone">{msg => <div className="form-errors">{msg}</div>}</ErrorMessage>
                            </div>
                        </div>

                        <br/>
                        <SkodaDataInfo/>

                        <br/>
                        <div className="text-info" style={{textTransform: 'uppercase'}}>
                            <b>Możesz udzielić także dodatkowych zgód celem marketingu przyszłego</b><br/>
                            (zgody są opcjonalne i&nbsp;dobrowolne, a&nbsp;ich udzielenie lub odmowa są&nbsp;niezależne od&nbsp;obsługi twojego zapytania)
                        </div>
                        <br/>

                        <div className="form-group">
                            <div className="form-check">
                                <Field className="form-check-input" id="agreeData" name="agreeData" type="checkbox"></Field>
                                <label htmlFor="agreeData" className="form-check-label">
                                    Zgadzam się na używanie przez <b>Volkswagen Group Polska Sp. z o.o. (VGP) oraz Škoda Auto a.s.</b> przekazanych danych, danych zebranych o moich zapytaniach i zainteresowaniach ofertach, zamówieniach i zleceniach w ramach relacji biznesowej z VGP lub z Autoryzowanym Dealerem lub Autoryzowanym Partnerem Serwisowym, w celu marketingu dot. produktów i usług marki Škoda oraz innych powiązanych z marką Škoda akcesoriów, produktów i usług motoryzacyjnych, w tym także w celu profilowania na potrzeby marketingu, realizacji działań posprzedażowych polegających na prowadzeniu i analizie badań satysfakcji klienta lub zainteresowania marką, produktami i usługami marki Škoda.
                                </label>
                            </div>
                            <ErrorMessage name="agreeData">{msg => <div className="form-errors">{msg}</div>}</ErrorMessage>
                        </div>

                        <label>Chcę otrzymać od VGP w/w informacje handlowe i&nbsp;marketingowe poprzez:</label>
                        <div className="form-group">
                            <div className="form-check">
                                <Field className="form-check-input" id="agreeCommunication_sms" name="agreeCommunication" value="sms" type="checkbox"></Field>
                                <label htmlFor="agreeCommunication_sms" className="form-check-label">SMS/MMS</label>
                            </div>
                            <div className="form-check">
                                <Field className="form-check-input" id="agreeCommunication_phone" name="agreeCommunication" value="phone" type="checkbox"></Field>
                                <label htmlFor="agreeCommunication_phone" className="form-check-label">Telefon</label>
                            </div>
                            <ErrorMessage name="agreeCommunication">{msg => <div className="form-errors">{msg}</div>}</ErrorMessage>
                        </div>

                        <SkodaDataMoreInfo/>
                        <br/>

                        <div className="form-group text-center">
                            {/*<button type="submit" className="button" disabled={!formikProps.isValid || !formikProps.dirty || formIsSubmitting}>Wyślij zgłoszenie</button>*/}
                            <button type="submit" className="button" disabled={formIsSubmitting}>Wyślij zgłoszenie</button>
                        </div>
                        <div className="form-group text-info text-center">
                            * Pola wymagane
                        </div>

                    </Form>
                </>
            )}
        </Formik>
    );
}
